export default __webpack_public_path__ + "static/media/loader.a709950a.svg";